/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';
import { mediaBreakpoints } from '../../../common/responsive';

export const styles = StyleSheet.create({
  content: {
    padding: 40,
    color: colors.steel,
    [mediaBreakpoints.mobile]: {
      ...mixins.padding(24, 24, 32, 24),
    },
  },
  heading: {
    fontSize: 24,
    fontWeight: 500,
    ...fonts.UntitledSans,
    marginBottom: 16,
    lineHeight: '1.3',
    textAlign: 'center',
    [mediaBreakpoints.mobile]: {
      fontSize: 18,
    },
  },
  description: {
    fontSize: 16,
    fontWeight: fonts.weight.book,
    marginBottom: 15,
    textAlign: 'left',
  },
  primaryButton: {
    marginTop: 25,
    marginBottom: 10,
  },
});

export const getStyleConfig = (isMobile: boolean) => ({
  padding: 0,
  borderRadius: 8,
  width: `calc(100% - 32px)`,
  maxWidth: isMobile ? 320 : 520,
});
